import { render, staticRenderFns } from "./python_settings.vue?vue&type=template&id=1b9a23c9&scoped=true"
import script from "./python_settings.vue?vue&type=script&lang=js"
export * from "./python_settings.vue?vue&type=script&lang=js"
import style0 from "./python_settings.vue?vue&type=style&index=0&id=1b9a23c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a23c9",
  null
  
)

export default component.exports